import React, { useEffect } from 'react';

const Toast = ({ message, isVisible, onClose }) => {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000); // Toast will disappear after 3 seconds
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);

    return (
        <div
            className={`fixed bottom-5 right-5 p-3 bg-green-600 text-white rounded-md transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
            style={{ pointerEvents: 'none' }}
        >
            {message}
        </div>
    );
};

export default Toast;
